export const NIS = 'nis';
export const AGENT_TRANSACTION_ID = 'agentTransactionId';
